/**
 * @generated SignedSource<<2c5a428e608c2a9e2264c5b204e987c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TabsSettingsRemoveTabMutation$variables = {
  streamId: string;
  tabId: string;
};
export type TabsSettingsRemoveTabMutation$data = {
  readonly StreamTab_RemoveTab: {
    readonly stream: {
      readonly id: string;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type TabsSettingsRemoveTabMutation = {
  response: TabsSettingsRemoveTabMutation$data;
  variables: TabsSettingsRemoveTabMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tabId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "tabId",
        "variableName": "tabId"
      }
    ],
    "concreteType": "RemoveTab",
    "kind": "LinkedField",
    "name": "StreamTab_RemoveTab",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamTabNode",
            "kind": "LinkedField",
            "name": "tabs",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherStreamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmbedded",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TabsSettingsRemoveTabMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TabsSettingsRemoveTabMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e00f906ae3623b4e78bad70272175f4b",
    "id": null,
    "metadata": {},
    "name": "TabsSettingsRemoveTabMutation",
    "operationKind": "mutation",
    "text": "mutation TabsSettingsRemoveTabMutation(\n  $streamId: ID!\n  $tabId: String!\n) {\n  StreamTab_RemoveTab(streamId: $streamId, tabId: $tabId) {\n    stream {\n      id\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e50c546146fb4ff330c1e590100ab75";

export default node;
